import { useState, useEffect, useContext } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { AuthContext } from "../context/auth";
import { useNavigation } from "react-router-dom";
import api from "../api/api";

const TokenExpiryModal = () => {

  const { setIsAuthenticated } = useContext(AuthContext);
  const [timeLeft, setTimeLeft] = useState(300); // 5 minutes (300s)
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {

    const tokenExpiration = localStorage.getItem("token_expiration");

    if (!tokenExpiration) return;

    const expirationTime = new Date(tokenExpiration).getTime();

    const interval = setInterval(() => {

      const now = new Date().getTime();
      const remainingTime = Math.max((expirationTime - now) / 1000, 0);
      setTimeLeft(Math.floor(remainingTime));

      if (remainingTime <= 60) {
        setShowModal(true); // Afficher le modale 1 min avant expiration
      }

      if (remainingTime <= 0) {
        clearInterval(interval);
        setShowModal(false);
        localStorage.removeItem("token");
        window.location.href = "/login"

      }
    }, 1000);

    return () => clearInterval(interval);
  }, [timeLeft]);

  const handleExtendSession = async () => {

    try {
      
      const response = await api.auth.auto_login();

      if (response.token) {

        console.log("Token renouvelé !");

        localStorage.setItem("token", response.token);
        const newExpiration = new Date().getTime() + 5 * 60 * 1000; // Ajout de 5 minutes
        localStorage.setItem("token_expiration", new Date(newExpiration).toISOString());
        setTimeLeft(300);
        setShowModal(false);
        setIsAuthenticated(true);
      }
    } catch (error) {
      console.error("Erreur de renouvellement du token :", error);
      // localStorage.removeItem("token");
      setIsAuthenticated(false);
    }
  };

  if (!showModal) return null;

  return (
    <motion.div
      initial={{ opacity: 0, x: -50 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -50 }}
      className="fixed bottom-4 left-4 bg-gray-900 text-white p-4 rounded-lg shadow-lg flex items-center space-x-4"
    >
      <div className="flex flex-col">
        <span className="text-sm font-semibold">Votre session expire bientôt !</span>
        <span className="text-lg font-bold text-red-400">
          Temps restant : {Math.floor(timeLeft / 60)}:{(timeLeft % 60).toString().padStart(2, "0")}
        </span>
      </div>
      <button
        onClick={handleExtendSession}
        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
      >
        Maintenir la connexion
      </button>
    </motion.div>
  );
};

export default TokenExpiryModal;
